import Vue from "vue";
import VueRouter from "vue-router";

import ApplicationForm from "@/components/employee/ApplicationForm.vue";
// import AdminApplications from '@/components/admin/AdminApplications.vue';
import Authenticator from "@/core/services/Authenticator.vue";
import PageNotFound from "@/components/PageNotFound.vue";
import Landing from "@/components/employee/Landing.vue";
// import AdminLayout from '@/components/admin/AdminLayout.vue';
import ViewSingleApplicationPrint from "@/components/admin/ViewSingleApplicationPrint.vue";
import DownloadApplicationFiles from "@/components/admin/DownloadApplicationFiles.vue";
import AdminApplications from "@/components/admin/AdminApplications.vue";
import AdminCompanies from "@/components/admin/AdminCompanies.vue";
import AdminDashboard from "@/components/admin/AdminDashboard.vue";
import AdminLoanTypes from "@/components/admin/AdminLoanTypes.vue";
// import ViewSingleApplicationEmail from '@/components/admin/ViewSingleApplicationEmail.vue';

import {
  //  AuthModeStrategyType, Amplify,
  Auth,
} from "aws-amplify";
// import awsconfig from "@/aws-exports";

Vue.use(VueRouter);

const routes = [
  {
    path: "/auth",
    name: "Authenticator",
    component: Authenticator,
  },
  {
    path: "/admin",
    name: "AdminDashboard",
    component: AdminDashboard,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/applications",
    name: "AdminApplications",
    component: AdminApplications,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/companies",
    name: "AdminCompanies",
    component: AdminCompanies,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/loan-types",
    name: "AdminLoanTypes",
    component: AdminLoanTypes,
    meta: { requiresAuth: true },
  },
  {
    path: "/view/:applicationId",
    name: "ViewSingleApplicationEmail",
    component: ViewSingleApplicationPrint,
  },
  {
    path: "/downloads/:applicationId",
    name: "DownloadApplicationFiles",
    component: DownloadApplicationFiles,
  },
  {
    path: "/print/:applicationId",
    name: "ViewSingleApplicationPrint",
    component: ViewSingleApplicationPrint,
    meta: { requiresAuth: true },
  },
  {
    path: "/",
    name: "Landing",
    component: Landing,
    // meta: { requiresAuth: true }
  },
  {
    path: "/apply/:companyId/:salaryFrequency",
    name: "Apply",
    component: ApplicationForm,
    // meta: { requiresAuth: true }
  },
  {
    path: "*",
    name: "NotFound",
    component: PageNotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (!requiresAuth) await Auth.signOut();

  // const isAuthenticated = await Auth.currentUserInfo()

  // Amplify.configure({
  //     ...awsconfig,
  //     aws_appsync_authenticationType: isAuthenticated ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM",
  //     DataStore: {
  //         authModeStrategyType: AuthModeStrategyType.MULTI_AUTH
  //     }
  // })

  if (!requiresAuth) {
    next();
  } else {
    const isAuthenticated = await Auth.currentUserInfo();

    if (requiresAuth && !isAuthenticated) {
      next({
        path: "/auth",
        query: { redirect: to.fullPath },
      });
    } else if (requiresAuth && isAuthenticated) {
      if (!to.meta.includesUsers) {
        // console.log(2.1)
        next();
      } else if (
        to.meta.includesUsers &&
        to.meta.includesUsers.includes(isAuthenticated.username)
      ) {
        // console.log(2.2)
        next();
      } else {
        // console.log(2.3)
      }
    }
  }
});

export default router;
